import React, { useEffect, useState } from "react";
import GoPremiumModal from "components/CustomWidgets/goPremiumModal";
import Input from "components/BaseWidgets/form/input";
import Button from "components/BaseWidgets/button";
import { CopyClipBoard } from "assets/icons";
import "./style.scss";
import whatsapp from "assets/images/svg/whatsapp.svg";
import fb_messenger from "assets/images/svg/fb_messenger.svg";
import messages from "assets/images/svg/messages.svg";
import instagram from "assets/images/svg/instagram.svg";
import snapchat from "assets/images/svg/snapchat.svg";
import ShareImage from "assets/images/svg/shareprofile.svg";
import AlertNotification from "../alertNotification";

function ShareModal({ open, onCancel, defaultLink = "" }) {
  const [copyLink, setCopyLink] = useState(defaultLink);

  useEffect(() => {
    setCopyLink(defaultLink);
  }, [defaultLink]);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(copyLink);
        AlertNotification("success", "Copied!");
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = copyLink;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const success = document.execCommand("copy");
        document.body.removeChild(textArea);
        AlertNotification(
          success ? "success" : "error",
          success ? "Copied!" : "Failed to copy",
        );
      }
    } catch (err) {
      AlertNotification("error", "Failed to copy");
    }
  };

  const handleShare = (platform) => {
    const encodedLink = encodeURIComponent(copyLink);
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodedLink}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}`;
        break;
      case "messenger":
        shareUrl = `fb-messenger://share/?link=${encodedLink}`;
        break;
      case "messages":
        shareUrl = `sms:?body=${encodedLink}`;
        break;
      case "instagram":
        AlertNotification(
          "info",
          "Instagram does not support direct link sharing.",
        );
        return;
      case "snapchat":
        shareUrl = `https://www.snapchat.com/scan?attachmentUrl=${encodedLink}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank");
  };

  const modalContent = (
    <div className="share-modal-content">
      <Input
        className="clip-board"
        id="profile-link"
        labelClass="label"
        label="Profile link"
        placeholder=""
        value={copyLink}
        readOnly
        icon={
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={handleCopy}
          >
            <CopyClipBoard />
          </span>
        }
      />

      <div className="icons-wrapper flex gap-3 items-center">
        <Button
          className="media-icon"
          variant="custom"
          icon={<img src={whatsapp} alt="WhatsApp" />}
          onClick={() => handleShare("whatsapp")}
        />
        <Button
          className="media-icon"
          variant="custom"
          icon={<img src={fb_messenger} alt="Messenger" />}
          onClick={() => handleShare("messenger")}
        />
        <Button
          className="media-icon"
          variant="custom"
          icon={<img src={messages} alt="Messages" />}
          onClick={() => handleShare("messages")}
        />
        <Button
          className="media-icon"
          variant="custom"
          icon={<img src={instagram} alt="Instagram" />}
          onClick={() => handleShare("instagram")}
        />
        <Button
          className="media-icon"
          variant="custom"
          icon={<img src={snapchat} alt="Snapchat" />}
          onClick={() => handleShare("snapchat")}
        />
      </div>
    </div>
  );

  return (
    <GoPremiumModal
      open={open}
      onCancel={onCancel}
      onOk={onCancel}
      modalClassName="share-modal"
      contentClass="modal-content-frame"
      heading="Share profile"
      headingClass="blog-modal-heading"
      contentTitle="Share this profile to others via link or social platforms."
      descriptionClass="modal-description"
      footerContent={modalContent}
      contentFooterClass="footer-frame w-full"
      headerImage={ShareImage}
    />
  );
}

export default ShareModal;
